import React from 'react';

// 5 个位置图标的内联 SVG。
// path 数据 1:1 抽自项目 src/assets/*_splash_placeholder.svg（官方占位立绘里的 icon 区块），
// 保证和 Pick 卡片中间显示的占位立绘视觉一致；改用 currentColor + opacity 让外层 CSS 可
// 通过 color 切换为未亮态/蓝色/红色，零图片下载。

const ICONS = {
  // 上单：双层 L 形角框 + 内部小方块
  top: {
    viewBox: '113 155 87 87',
    body: (
      <>
        <rect x="145" y="187" width="24" height="24" fill="currentColor" opacity="0.45" />
        <polygon
          points="186 175.81 186 228 133.3 228 121.18 240 198 240 198 163.93 186 175.81"
          fill="currentColor"
          opacity="0.45"
        />
        <polygon
          points="130 219 130 172 177 172 192 157 115 157 115 234 130 219"
          fill="currentColor"
        />
      </>
    ),
  },
  // 打野：三簇枝叶
  jungle: {
    viewBox: '115 155 80 90',
    body: (
      <>
        <path
          fill="currentColor"
          d="M127,217l25.5,24,6-7.5s6-37.5-27-76.5c7.5,21,12,42,12,51-6-13.5-21-25.5-27-27C127,193,127,217,127,217Z"
        />
        <path
          fill="currentColor"
          d="M155.5,188.5s7.5-21,21-31.5C172,169,165,187.5,162,210A90.81,90.81,0,0,0,155.5,188.5Z"
        />
        <path
          fill="currentColor"
          d="M163,230l13-14s4-23.5,14.5-34C178.5,188,163,206,163,230Z"
        />
      </>
    ),
  },
  // 中单：交错对角条带
  mid: {
    viewBox: '113 155 87 87',
    body: (
      <>
        <polygon
          points="180 157 115 222 115 240 133 240 198 175 198 157 180 157"
          fill="currentColor"
        />
        <polygon
          points="127 200.89 127 169 158.89 169 170.89 157 115 157 115 212.89 127 200.89"
          fill="currentColor"
          opacity="0.45"
        />
        <polygon
          points="186 196.11 186 228 154.11 228 142.11 240 198 240 198 184.11 186 196.11"
          fill="currentColor"
          opacity="0.45"
        />
      </>
    ),
  },
  // 下路 / ADC：与 top 同款角框，但内方块上下镜像
  adc: {
    viewBox: '113 155 87 87',
    body: (
      <>
        <rect
          x="144"
          y="186"
          width="24"
          height="24"
          transform="translate(312 396) rotate(180)"
          fill="currentColor"
          opacity="0.45"
        />
        <polygon
          points="127 221.19 127 169 179.7 169 191.82 157 115 157 115 233.07 127 221.19"
          fill="currentColor"
          opacity="0.45"
        />
        <polygon
          points="183 178 183 225 136 225 121 240 198 240 198 163 183 178"
          fill="currentColor"
        />
      </>
    ),
  },
  // 辅助：菱形 + 双翼羽 + 顶部 V 字
  support: {
    viewBox: '90 154 132 92',
    body: (
      <>
        <path
          fill="currentColor"
          d="M166.28,182.11,172.91,202l18.21-3.31-11.59-13.25s14.91-1.65,31.47-13.25H174.56Z"
        />
        <path
          fill="currentColor"
          d="M149.72,182.11,143.09,202l-18.22-3.31,11.6-13.25s-14.91-1.65-31.47-13.25h36.44Z"
        />
        <polygon
          points="161.31 185.42 158 187.08 154.69 185.42 143.09 233.45 158 243.39 172.91 233.45 161.31 185.42"
          fill="currentColor"
        />
        <polygon
          points="141.44 160.58 158 182.11 174.56 160.58 169.59 155.61 146.41 155.61 141.44 160.58"
          fill="currentColor"
        />
      </>
    ),
  },
};

// pick 槽位 1..5 → 位置标识
export const SLOT_TO_POSITION = ['top', 'jungle', 'mid', 'adc', 'support'];

// 单个位置的中文标签（hover 提示用）
export const POSITION_CN = {
  top: '上单',
  jungle: '打野',
  mid: '中单',
  adc: '下路',
  support: '辅助',
};

const PositionIcon = ({ position, size = 16, className }) => {
  const data = ICONS[position];
  if (!data) return null;
  return (
    <svg
      viewBox={data.viewBox}
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      {data.body}
    </svg>
  );
};

export default PositionIcon;
